module.exports = __webpack_public_path__ + "media/country_flags/sg-29fc452f.png";